import React, { useState } from 'react'
import styles from './index.scss'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import classnames from 'classnames'
import { SearchBar } from 'antd-mobile'
import LocationTab from './component/locationTabs'
import SearchList from './component/searchList'
import { DownOutline, UpOutline } from 'antd-mobile-icons'
import request from '@/libs/functions/request'

export function fetchApi({
  params,
  url,
}: {
  params?: any;
  url?: string;
}) {
  return request({
    uri: url || '/api/business/appointment/order/getPhonePreList',
    params,
    method: 'POST',
    options: { isShowMessage: false, resolveData: true, hasLoading: false },
  })
}

const AddonBefore: React.FC<any> = props => {
  const [visible, updateVisible] = useState(false)
  const [dataSource, updateDataSource] = useState<any>([])
  const [inputValue, updateInputValue] = useState()
  async function fetchMoreData() {
    if (dataSource?.length > 0) {
      updateVisible?.(true)
      return
    }
    const res: any = await fetchApi?.({
      params: props?.params,
      url: props?.url
    })
    const _data = res?.code === -1 ? [{
      "code": "B51",
      "phonePre": "86",
      "name": "中国",
      "firstWord": "Z"
    }] : res
    updateDataSource(_data?.map(item => ({
      ...item,
      phonePre: item?.phonePre?.includes?.('+') ? item?.phonePre : `+${item?.phonePre}`
    })))
    updateVisible?.(true)
  }

  return (
    <div className={styles['dp-location']}>
      <div
        className={styles['dp-location-bar']}
        onClick={() => {
          if (!props?.disabled) {
            fetchMoreData?.()
            updateInputValue?.('')
          }
        }}
      >
        <span
          className={classnames({
            [styles['dp-location-bar-desc']]: true,
            [styles['dp-location-bar-desc--active']]: props?.value,
          })}
        >
          {props?.value || `${lang['请选择']}${props?.title || ''}`}
        </span>
        {!visible ? <DownOutline className={styles['dp-location-bar-icon']} /> : <UpOutline className={styles['dp-location-bar-icon']} />}
      </div>
      {visible && (
        <DpBusinessPopup
          visible={visible}
          {...props}
          title={lang['国际区号']}
          onClose={() => {
            updateVisible(!visible)
          }}
          onConfirm={() => {
            updateVisible(!visible)
          }}

          headerStyle={{
            borderBottomWidth: 0,
            color: 'var(--text-color, #202020)',
            background: 'var(--page-bg-color, #F5F6F8)'
          }}
          titleStyle={{
            color: 'var(--text-color, #202020)',
            textAlign: 'center',
          }}
          bodyStyle={{
            paddingBottom: 0,
            ...props?.customStyles,
            background: 'var(--page-bg-color, #F5F6F8)',
          }}
          popupBodyStyles={{
            background: 'var(--page-bg-color, #F5F6F8)',
            maxHeight: '100vh',
          }}
          containerStyles={{
            padding: '8px 10px 10px',
            background: 'var(--page-bg-color, #F5F6F8)',
          }}
          popupProps={{
            getContainer: () => document.body
          }}
        >
          <div className={styles['dp-location-container']}>
            <SearchBar
              showCancelButton
              placeholder={`${lang['请输入']}${props?.title || ''}`}
              className={styles['dp-location-input']}
              style={{ '--border-radius': '18px' }}
              onChange={(e) => updateInputValue(e)}
              onClear={() => updateInputValue('')}
            />
            <div className={styles['dp-location-body']}>
              {inputValue ? (
                <SearchList
                  data={dataSource}
                  inputValue={inputValue}
                  onChange={(item) => {
                    props?.onChange?.(item?.phonePre)
                    updateVisible(!visible)
                    updateInputValue('')
                  }}
                />
              ) : (
                <LocationTab
                  data={dataSource}
                  onChange={(item) => {
                    props?.onChange?.(item?.phonePre)
                    updateVisible(!visible)
                    updateInputValue('')
                  }}
                />
              )}
            </div>
          </div>
        </DpBusinessPopup>
      )}
    </div>
  )
}

export default AddonBefore
